module.exports = __webpack_public_path__ + "img/CALENDER.57ce3d40.svg";